import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { createWound, updateWound } from '../../api/homeWounds';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './wounds.styl';
var WoundsHomeDetailsModal = /** @class */ (function (_super) {
    __extends(WoundsHomeDetailsModal, _super);
    function WoundsHomeDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            imageInputError: false,
            indicationsInputError: false,
            indicationsEditorState: '',
        };
        _this.dropZone = null;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.wound,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                console.error(response);
                _this.setState({
                    attachedImage: response.data.fileName,
                });
                _this.dropZone.files = [];
            }
        };
        return _this;
    }
    WoundsHomeDetailsModal.prototype.componentDidMount = function () {
        if (this.props.homeWound) {
            var homeWound = this.props.homeWound;
            this.setState({
                attachedImage: homeWound.image,
                indicationsEditorState: homeWound.indications || '',
            });
        }
    };
    WoundsHomeDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        var image = this.state.attachedImage;
        if (!image || image.length === 0) {
            this.setState({ imageInputError: true });
            valid = false;
        }
        var indications = this.indicationRef.getContent();
        if (isHtmlEmpty(indications)) {
            this.setState({ indicationsInputError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            image: this.state.attachedImage,
            indications: indications,
        };
        this.setState({ loading: true });
        if (this.props.homeWound) {
            request.id = this.props.homeWound.id;
            updateWound(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createWound(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    WoundsHomeDetailsModal.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var i18n = props.store.i18n;
        var homeWound = props.homeWound;
        var loading = state.loading, indicationsEditorState = state.indicationsEditorState;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.woundsAddView },
                React.createElement("p", { className: S.woundsHeaderText }, homeWound ?
                    i18n.woundsUpdateTitle
                    :
                        i18n.woundsCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: homeWound === null || homeWound === void 0 ? void 0 : homeWound.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIcon),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.attachedImage ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.attachedImage) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZone = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.imageInputError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputIndicationsTitle),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.indicationRef = editor; }, apiKey: getEditorKey(), initialValue: indicationsEditorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.indicationsInputError ? 'inputErrorActive' : '') }, i18n.validationIndicationsError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.woundsModalButton, type: "submit", spinner: loading }, homeWound ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.woundsModalButton + " " + S.woundsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], WoundsHomeDetailsModal.prototype, "onSubmit", null);
    WoundsHomeDetailsModal = __decorate([
        inject('store'),
        observer
    ], WoundsHomeDetailsModal);
    return WoundsHomeDetailsModal;
}(React.Component));
export { WoundsHomeDetailsModal };
